import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { AI_IMAGE_FILE } from './constants';

function AiIcon(props) {
  const { size, ...rest } = props;
  let dimension = {
    width: '24',
    height: '24',
  };
  if (size === 'small') {
    dimension = {
      width: '20',
      height: '20',
    };
  }
  return (
    <SvgIcon {...rest}>
      <image
        href={AI_IMAGE_FILE}
        {...dimension}
        x="0"
        y="0"
        preserveAspectRatio="xMidYMid meet"
      />
    </SvgIcon>
  );
}

// Needed for Menu
export function AiIconSmall() {
  return <AiIcon size="small" />;
}

export default AiIcon;
